import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    SaveThirdPartyPayoffRowRequest,
    SaveThirdPartyPayoffRowResponse,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

const ConflictStatusCode = 409;

export interface SaveThirdPartyPayoffRowParams extends SaveThirdPartyPayoffRowRequest {
    engagementId: number;
    tableRowId: number;
}

export interface SaveThirdPartyPayoffRowRejection {
    isConflict: boolean;
}

export const SaveThirdPartyPayoffRow = createAsyncThunk(
    'flowOfFunds/saveThirdPartyPayoffRow',
    async (params: SaveThirdPartyPayoffRowParams, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}`,
                {
                    cells: params.cells,
                    isPayoffDateProvided: params.isPayoffDateProvided,
                    payoffDate: params.payoffDate,
                    isPerDiemProvided: params.isPerDiemProvided,
                    perDiem: params.perDiem,
                }
            );

            if (response.status === ConflictStatusCode) {
                return dispatch.rejectWithValue({
                    isConflict: true,
                } as SaveThirdPartyPayoffRowRejection);
            }

            if (response.status !== 200) {
                throw new Error('Failed to save the row');
            }

            return response.data as SaveThirdPartyPayoffRowResponse;
        } catch (error) {
            createNotification('Could not save the row changes.', 'error');
            return dispatch.rejectWithValue({
                isConflict: false,
            } as SaveThirdPartyPayoffRowRejection);
        }
    }
);
